import { getUsers as getUsersService } from '@shared/services/api/userService';
import { useCallback, useRef, useState } from 'react';

export function useUsers({ search }) {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const previousSearch = useRef(search);
  const [totalUsers, setTotalUsers] = useState(0);

  const getUsers = useCallback(async ({ search, currentPage, pageSize, sorting = {} }) => {
    try {
      setLoading(true);
      setError(null);
      previousSearch.current = search;
      const response = await getUsersService(search, currentPage, pageSize, sorting);
      const { data_set, rows_count } = response?.data || { data_set: [], rows_count: 0 };
      setUsers(data_set);
      setTotalUsers(rows_count);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    // properties
    users,
    loading,
    totalUsers,
    error,

    // methods
    getUsers,
  };
}
